const articleDocument = document.querySelector('.article-template');
const getAllTitles = articleDocument.querySelectorAll("h2, h3");
const getSummary = document.querySelector(".summary-titles_wrapper");

if(getAllTitles.length > 0) {
  let tagCount = 1;
  getAllTitles.forEach(function(element) {
    let textTitle = element.textContent;
    let className = "";
    if(element.nodeName == "H3") {
      className = "link_small";
    }
    element.setAttribute("id", "customTitle" + tagCount);
    getSummary.innerHTML += `<li class="${className}"><a href="#customTitle${tagCount}" class="scroll_link_trigger">${textTitle}</a></li>`;
    tagCount++;
  })
}